// extracted by mini-css-extract-plugin
export default {"profileImage":"profileImage_profileImage__DCc0G","large":"profileImage_large__Gr7jp","medium":"profileImage_medium__FDRoK","small":"profileImage_small__kPBuK"};